export const dataHooks = {
    hiddenRadio: 'hidden-radio',
    label: 'label',
    icon: 'icon',
};
//# sourceMappingURL=constants.js.map